import React from "react";

const QuestionnaireContext = React.createContext({
  questionnaire: null,
  setQuestionnaire: () => {},
});

export default QuestionnaireContext;